"use client";
import React from "react";

const AnalyticsUsageChart: React.FC = () => {
  const months = ["Jan", "Mar", "May", "Jul", "Sep", "Nov", "Dec"];

  // This would typically come from a data source
  const chartData = [
    { height1: 12, height2: 14, height3: 62 },
    { height1: 4, height2: 16, height3: 74 },
    { height1: 20, height2: 11, height3: 50 },
    { height1: 10, height2: 14, height3: 65 },
    { height1: 20, height2: 11, height3: 50 },
    { height1: 6, height2: 16, height3: 71 },
    { height1: 12, height2: 14, height3: 62 },
    { height1: 10, height2: 14, height3: 65 },
    { height1: 12, height2: 14, height3: 62 },
    { height1: 8, height2: 16, height3: 68 },
    { height1: 4, height2: 16, height3: 74 },
    { height1: 14, height2: 14, height3: 59 },
  ];

  return (
    <div className="mt-6 w-full">
      <div className="flex gap-1 min-h-60">
        <div className="relative flex-1 shrink w-full basis-0 min-w-60">
          {/* Y-axis */}
          <div className="z-0 flex-1 w-full">
            <div className="flex gap-2 items-center w-full min-h-[22px]">
              <div className="flex-1 shrink self-stretch my-auto w-full border border-gray-100 border-solid basis-0 min-h-px min-w-60" />
            </div>
            <div className="flex gap-2 mt-6 w-full min-h-[17px]" />
            <div className="flex gap-2 mt-6 w-full min-h-[17px]" />
            <div className="flex gap-2 mt-6 w-full min-h-[17px]" />
            <div className="flex gap-2 mt-6 w-full min-h-[17px]" />
            <div className="flex gap-2 items-center mt-6 w-full min-h-[17px]">
              <div className="flex-1 shrink self-stretch my-auto w-full border border-gray-100 border-solid basis-0 min-h-px min-w-60" />
            </div>
          </div>

          {/* X-axis */}
          <div className="flex z-0 gap-6 justify-between items-center px-2 w-full text-xs text-right whitespace-nowrap text-slate-600">
            {months.map((month, index) => (
              <div key={index} className="self-stretch my-auto">
                {month}
              </div>
            ))}
          </div>

          {/* Chart data */}
          <div className="flex overflow-hidden absolute inset-x-0 top-0 z-0 flex-col w-full bottom-[27px] max-w-[311px]">
            <div className="flex overflow-hidden gap-2 justify-between px-3 min-h-[213px]">
              {chartData.map((data, index) => (
                <div key={index} className="flex flex-col h-full justify-end">
                  <div 
                    className="w-4 bg-blue-700" 
                    style={{ height: `${data.height3}px` }}
                  />
                  <div 
                    className="w-4 bg-blue-500" 
                    style={{ height: `${data.height2}px` }}
                  />
                  <div 
                    className="w-4 bg-gray-200" 
                    style={{ height: `${data.height1}px` }}
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AnalyticsUsageChart;
